import { makeStyles } from "@material-ui/styles";
import React from "react";

const useStyles = makeStyles(theme => ({
    tag: {
        display: "inline-block",
        padding: "2px 10px",
        borderRadius: "12px",
        fontSize: "0.75em",
        fontWeight: 600,
        color: "#FFF",
        marginRight: "4px",
        marginTop: "2px",
        whiteSpace: "nowrap",
        lineHeight: 1.4,
        letterSpacing: "0.2px",
        textTransform: "none",
        boxShadow: "0 1px 2px rgba(0,0,0,0.08)"
    }
}));

const ContactTag = ({ tag }) => {
    const classes = useStyles();

    return (
        <div className={classes.tag} style={{ backgroundColor: tag.color || "#3AC0E7" }}>
           {tag.name || tag.label || tag.title || ""}
        </div>
    )
}

export default ContactTag;